<template>
    <el-autocomplete
        size="small"
        v-model="customerIds"
        :fetch-suggestions="querySearchAsync"
        :disabled="disable"
        :placeholder="placeholder"
        @select="handleChange"
        @input="handleInput"
        @blur="handleBlur">
        <template slot-scope="{ item }">
            <div class="label" :title="item.value" >{{ item.value }} <span v-if="item.child" style="color: red;">(主)</span></div>
        </template>
    </el-autocomplete>
</template>


<script>
import CommonService from "~/services/common";

export default {
    name: "CustomerSelect",
    props: {
        customerIdss: "",
        placeholder:{
          required:false,
          default:'请输入关键词'
        },
        // customerId: "",
        //isMultiple: true,
        onlyShow: false, //true:只做展示不可搜索 例如联系人编辑，就是只做展示的
        scenary:false,//场景值，部分场景不需要查找出全部客户，比如创建订单的时候，只需要查找出与业务员绑定的客户
    },
    data() {
        return {
            //定义变量
            //loading: true,
            customerIds: null,
            //list: [],
            //isMany: true, //是否支持多个, 此处为了兼容外部传入组件内的值类型错误问题
            disable:false,   //禁止选择
            selectedItem: null,
        };
    },

    created: function() {

        if(typeof this.customerIdss != 'undefined'){
            this.customerIds = this.customerIdss;
        }
        if (this.onlyShow) {
            this.disable = true;
        } else {
            this.disable = false;
        }
    },


    methods: {
        querySearchAsync(queryString, cb) {
            let qs = (queryString || '').toString().trim() || undefined;
            let params = {
                fields: 'id,name',
                limit: 10,
                name: qs,
                scenary:this.scenary
            };
            CommonService.getCustomerList(params).then(res => {
                if (!res.data) return;
                // let results = res.data.filter(item => {
                //     if (!qs) return true;
                //         return item.name.toString().indexOf(qs)> -1;
                // }).map( item => {
                //     return { 
                //         value: item.name, 
                //         label: item.id 
                //     };
                // });
                let results = res.data.map( item => {
                    return { 
                        value: item.name, 
                        label: item.id,
                        child: item.child,
                        query_value: item.sensitive_masked ? item.id : item.name,
                        sensitive_masked: !!item.sensitive_masked,
                    };
                });
                cb(results)
            });
        },

        //select value值变化时触发
        handleChange(item) {
            this.selectedItem = item;
            this.$emit("change", item); 
        },

        handleInput(value) {
            if (this.selectedItem && value !== this.selectedItem.value) {
                this.selectedItem = null;
            }
        },

        handleBlur($event) {
            if (this.selectedItem && $event.target.value === this.selectedItem.value) {
                this.$emit("change", this.selectedItem);
                return;
            }
            this.$emit("change", $event.target);
        },
        //对输入框进行重置     
        reset(){
            this.customerIds = '';
            this.selectedItem = null;
        }           
    }
}



</script>


// WEBPACK FOOTER //
// src/widgets/CustomerSelect.vue